import { GetWalletDetailsV2Query } from '@/types/generated/graphql';
import { capitalize } from '@shared/utils/capitalize';

export function getIsAutoRechargeEnabled(data: GetWalletDetailsV2Query | undefined): boolean {
  return data?.getWalletDetailsV2?.data?.isAutoRechargeEnabled ?? false;
}

export function formatOrderType(type?: string | null): string {
  if (!type) return '';
  return capitalize(type.replace(/_/g, ' '));
}
